import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d72cf566"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "editor-layout"
};
const _hoisted_2 = {
  class: "field-label"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "题干", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "field-tip"
}, "题干必须且只能包含一个 ____ 空位。", -1));
const _hoisted_5 = {
  class: "option-editor-list"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "field-tip"
}, "单选圆点表示正确答案。", -1));
const _hoisted_7 = {
  class: "preview-panel"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview-title"
}, "学生端预览", -1));
const _hoisted_9 = {
  class: "editor-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_form = _resolveComponent("el-form");
  const _component_TextAnalogyQuestion = _resolveComponent("TextAnalogyQuestion");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
    ref: "formRef",
    model: $data.form,
    rules: $data.rules,
    "label-position": "top",
    class: "editor-form"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "作答说明",
      prop: "instructionText"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.instructionText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.instructionText = $event),
        type: "textarea",
        rows: 2,
        maxlength: "500",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "stemText"
    }, {
      label: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_button, {
        text: "",
        type: "primary",
        onClick: $options.insertBlank
      }, {
        default: _withCtx(() => [_createTextVNode("插入空位 ____")]),
        _: 1
      }, 8, ["onClick"])])]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.stemText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.stemText = $event),
        type: "textarea",
        rows: 4,
        maxlength: "1000",
        "show-word-limit": "",
        placeholder: "例如：卧薪尝胆 之于 勾践，犹如 ____"
      }, null, 8, ["modelValue"]), _hoisted_4]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "四个选项",
      prop: "options"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.options, option => {
        return _openBlock(), _createElementBlock("div", {
          key: option.key,
          class: "option-editor-row"
        }, [_createVNode(_component_el_radio, {
          modelValue: $data.form.rightAnswer,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.rightAnswer = $event),
          label: option.key,
          class: "answer-radio"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(option.key), 1)]),
          _: 2
        }, 1032, ["modelValue", "label"]), _createVNode(_component_el_input, {
          modelValue: option.text,
          "onUpdate:modelValue": $event => option.text = $event,
          maxlength: "200",
          "show-word-limit": "",
          placeholder: `输入选项 ${option.key}`
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])]);
      }), 128))]), _hoisted_6]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "题目解析",
      prop: "analysisText"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.analysisText,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.analysisText = $event),
        type: "textarea",
        rows: 5,
        maxlength: "4000",
        "show-word-limit": "",
        placeholder: "保存草稿时可暂不填写，发布前必须补充。"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("aside", _hoisted_7, [_hoisted_8, _createVNode(_component_TextAnalogyQuestion, {
    question: $options.previewQuestion,
    interactive: false
  }, null, 8, ["question"])])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('cancel'))
  }, {
    default: _withCtx(() => [_createTextVNode("取消")]),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    loading: $data.saving,
    onClick: $options.saveDraft
  }, {
    default: _withCtx(() => [_createTextVNode("保存草稿")]),
    _: 1
  }, 8, ["loading", "onClick"])])], 64);
}